import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges, ViewChild, ViewEncapsulation,
} from '@angular/core';
import {MatCalendar, MatCalendarCellCssClasses} from "@angular/material/datepicker";

@Component({
  selector: 'app-mini-calendar',
  templateUrl: './mini-calendar.component.html',
  styleUrls: ['./mini-calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MiniCalendarComponent  implements OnInit, OnChanges, AfterViewInit, OnChanges {
  @Input() selectedDate: Date = new Date();
  @Input() currentMonthEvents: CalendarEvent[];

  @Output() dateChanged = new EventEmitter<Date>();
  @Output() monthChanged= new EventEmitter<Date>();


  @ViewChild('calendar') calendar: MatCalendar<Date>;
  private previousMonth: number;
  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.calendar.stateChanges.subscribe(() => {
      this.checkMonthChange();
    });
  }
  checkMonthChange() {
    const activeDate = new Date(this.calendar.activeDate);
    const currentMonth = activeDate.getMonth();

    if (currentMonth !== this.previousMonth) {
      this.monthChanged.emit(activeDate)
      this.previousMonth = currentMonth;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentMonthEvents'] && this.calendar) {
      this.calendar.updateTodaysDate();
      this.highlightDates();
    }
  }
  highlightDates() {
    return (date: Date, view): MatCalendarCellCssClasses => {
      if(view == 'month'){
        date = new Date(date);
        /*if(this.currentMonthEvents) {
          for (let range of this.currentMonthEvents.vacations) {
            const start = new Date(range.from);
            const end = new Date(range.to);
            if (date >= start && date <= end) {
              return 'vacation-range';
            }
          }
        }*/
        if(this.currentMonthEvents) {
          for (let d of this.currentMonthEvents) {
            const dd = new Date(d.date);
            if (dd.getDate() === date.getDate() && dd.getMonth() === date.getMonth() && dd.getFullYear() === date.getFullYear()) {
              return 'special-date';
            }
          }
        }
      }
      return '';
    };
  }

  dateFilter = (date: Date | null): boolean => {
    if (!date) return true;
    //if (!this.currentMonthEvents?.vacations) return true;

    /*for (let range of this.currentMonthEvents.vacations) {
      const start = new Date(range.from);
      const end = new Date(range.to);

      // If date is within the vacation range, return false (date is disabled)
      if (date >= start && date <= end) {
        return false;
      }
    }*/
    return true;
  };



  onDateChanged(event) {
    if(!event) {
      return;
    }
    this.dateChanged.emit(event);
  }
}

export interface CalendarEvent {
  date: Date;
  type: string;
}
